import { InputTextProps } from '../../../../components/atoms/Input/type';
import { html, View } from 'rune-ts';
import { InputText } from '../../../../components/atoms/Input/InputText';
import klass from './CreatorInputText.module.scss';
import { getCheckEmailApi, getCheckNameApi } from '../../../../../features/Creator/api';
import { koreanSchema } from '../../validate/validators';

export class CreatorInputText extends View<InputTextProps> {
  input_text = new InputText(this.data);

  override template() {
    return html` <div class="${klass.text_input}">${this.input_text}</div> `;
  }

  override onRender() {
    if (this.data.custom_klass === 'domain_name_input') {
      this.delegate('focusout', '.domain_name_input', async () => {
        const domain_name = this.input_text.getValue();
        if (!domain_name) return;

        const response = await getCheckNameApi({ name: domain_name });
        if (!response) {
          this.input_text.inputHelperView.setIsError(true, ET('mps2::ad_res::domain_duplicate'));
          this.input_text.redraw();
        }
      });

      this.delegate('keyup', '.domain_name_input', () => {
        this.input_text.inputHelperView.setErrorMessage(ET('mps2::ad_res::domain_validation'));
      });
    }

    if (this.data.custom_klass === 'email_input') {
      this.delegate('focusout', '.email_input', async () => {
        const email = this.input_text.getValue();
        if (!email) return;

        const response = await getCheckEmailApi({ email });
        if (!response) {
          this.input_text.inputHelperView.setIsError(true, ET('mps2::ad_res::email_duplicate'));
          this.input_text.redraw();
        }
      });

      this.delegate('keyup', '.email_input', () => {
        this.input_text.inputHelperView.setErrorMessage(ET('mps2::ad_res::email_error'));
      });

      this.delegate('input', '.email_input input', (e) => {
        const value = (e.target as HTMLInputElement)?.value;
        const result = koreanSchema.safeParse(value);
        if (result.success) this.input_text.setValue(value);
      });

      this.delegate('compositionstart', '.email_input input', (e) => {
        const target = e.target as HTMLInputElement;
        target.blur();
        requestAnimationFrame(() => target.focus());
      });
    }
  }

  getValue() {
    return this.input_text.getValue();
  }

  isError() {
    return this.input_text.isError();
  }

  isValidate() {
    return Boolean(this.getValue() && !this.isError());
  }
}
